<template>
    <v-navigation-drawer
            fixed
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
            :mobile-break-point="1281"
            v-model="inputValue"
    >
        <v-list dense expand>
            <v-list-tile :to="'/'" ripple>
                <v-list-tile-action>
                    <v-icon>home</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        Inicio
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <template v-for="item in items">
                <v-list-group
                    v-if="item.items"
                    :group="item.group"
                    no-action>
                    <v-list-tile slot="activator" ripple>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.title }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(subItem, i) in item.items">
                        <v-list-group
                                v-if="subItem.items"
                                :group="subItem.group"
                                sub-group>
                            <v-list-tile slot="activator" ripple>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ subItem.title }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile
                                    v-for="(grand, i) in subItem.items"
                                    :key="i"
                                    :to="genChildTarget(item, grand)"
                                    :href="grand.href"
                                    ripple>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ grand.title }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list-group>
                        <v-list-tile v-else
                                     :key="i"
                                     :to="genChildTarget(item, subItem)"
                                     :href="subItem.href"
                                     :target="subItem.target"
                                     ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ subItem.title }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list-group>
                <v-list-tile v-else
                             ripple
                             :to="!item.href ? { name: item.name } : null"
                             :href="item.href"
                             :disabled="item.disabled"
                             :target="item.target"
                             rel="noopener"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.title }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
            <v-list-tile @click="togglePush">
                <v-list-tile-action>
                    <v-icon v-if="isPushEnabled">notifications_active</v-icon>
                    <v-icon v-else>notifications_none</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title v-if="isPushEnabled">
                        Desactivar Notificaciones
                    </v-list-tile-title>
                    <v-list-tile-title v-else>
                        Activar Notificaciones
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
                <v-list-tile-action>
                    <v-icon>exit_to_app</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        Cerrar Sesión
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import appDrawerItems from '@/data/layout/app-drawer-items'
  import { AUTH_LOGOUT, PUSH_NOTIFICATION, PUSH_NOTIFICATION_UNSUBSCRIBE } from '@/store/mutation-types'
  import { camel } from '@/util/helpers'
  import axios from 'axios'

  export default {
    name: 'AppDrawer',
    data: () => ({
      items: appDrawerItems
    }),
    computed: {
      ...mapState({
        appDrawer: state => state.app.appDrawer,
        isPushEnabled: state => state.app.pushNotificationEnabled
      }),
      inputValue: {
        get () {
          return this.appDrawer
        },
        set (value) {
          this.drawer(value)
        }
      }
    },

    mounted () {
      this.initialiseServiceWorker()
    },

    methods: {
      ...mapMutations({
        drawer: 'DRAWER'
      }),
      logout: function () {
        this.$store.dispatch(AUTH_LOGOUT)
        this.$router.push('/login')
      },
      genChildTarget (item, subItem) {
        if (subItem.href) return
        return { name: `${item.group}/${camel(subItem.name)}` }
      },

      initialiseServiceWorker () {
        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
          console.log('Notifications aren\'t supported.')
          return
        }
        if (Notification.permission === 'denied') {
          console.log('The user has blocked notifications.')
          return
        }
        if (!('PushManager' in window)) {
          console.log('Push messaging isn\'t supported.')
          return
        }

        navigator.serviceWorker.ready.then(registration => {
          registration.pushManager.getSubscription()
            .then(subscription => {
              if (!subscription) {
                return
              }

              this.$store.commit(PUSH_NOTIFICATION, true)
            })
            .catch(e => {
              console.log('Error during getSubscription()', e)
            })
        })
      },

      /**
       * Subscribe for push notifications.
       */
      subscribe () {
        navigator.serviceWorker.ready.then(registration => {
          const options = { userVisibleOnly: true }
          const vapidPublicKey = 'BC4ArJJJqzMHUPtzREd2nxTA6sIiFduzWjrwkb321wI0Qgb5aEtmafSTFTEZ1tU0pL26YMcTTF9j801CN15SfSs'
          if (vapidPublicKey) {
            options.applicationServerKey = this.urlB64ToUint8Array(vapidPublicKey)
          }

          registration.pushManager.subscribe(options)
            .then(subscription => {
              this.$store.commit(PUSH_NOTIFICATION, true)
              this.updateSubscription(subscription)
            })
            .catch(e => {
              if (Notification.permission === 'denied') {
                console.log('Permission for Notifications was denied')
              } else {
                console.log('Unable to subscribe to push.', e)
              }
            })
        })
      },

      /**
       * Unsubscribe from push notifications.
       */
      unsubscribe () {
        this.$store.dispatch(PUSH_NOTIFICATION_UNSUBSCRIBE)
      },

      /**
       * Send a request to the server to update user's subscription.
       *
       * @param {PushSubscription} subscription
       */
      updateSubscription (subscription) {
        const key = subscription.getKey('p256dh')
        const token = subscription.getKey('auth')
        const data = {
          endpoint: subscription.endpoint,
          key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
          token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
        }

        axios.post('/alumno/subscriptions', data)
      },

      /**
       * Toggle push notifications subscription.
       */
      togglePush () {
        this.askPermission().then(() => {
          console.log(this.isPushEnabled)
          if (this.isPushEnabled) {
            this.unsubscribe()
          } else {
            this.subscribe()
          }
        })
      },

      // convert applicationServerPublicKey
      urlB64ToUint8Array (base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4)
        const base64 = (base64String + padding)
          .replace(/-/g, '+')
          .replace(/_/g, '/')

        const rawData = window.atob(base64)
        const outputArray = new Uint8Array(rawData.length)

        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i)
        }
        return outputArray
      },

      askPermission () {
        return new Promise((resolve, reject) => {
          const permissionResult = Notification.requestPermission((result) => {
            resolve(result)
          })

          if (permissionResult) {
            permissionResult.then(resolve, reject)
          }
        }).then((permissionResult) => {
          if (permissionResult !== 'granted') {
            throw new Error('We weren\'t granted permission.')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/core/AppDrawer.vue